import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DocumentState {
  isHorizontal: boolean;
}

const initialState: DocumentState = {
  isHorizontal: true,
};

const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setHorizontalOrientation: (state, action: PayloadAction<boolean>) => {
      state.isHorizontal = action.payload;
    },
    toggleOrientation: (state) => {
      state.isHorizontal = !state.isHorizontal;
    },
  },
});

export const { setHorizontalOrientation, toggleOrientation } =
  documentSlice.actions;

export default documentSlice.reducer;
